<template>
<v-app>
    <!-- <v-app-bar flat app height="90" color="red">
      <v-spacer></v-spacer>
      <a href="https://pappyon.com/">
      <img class="mr-2" src="../assets/header-logo.svg" height="70"/>
      </a>
    </v-app-bar> -->
    <v-app-bar
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            app
            :color="isDarkModeActivated? '' : 'secondary'"
            dark
        >
            <v-toolbar-title
            style="width: 300px"
            class="ml-0 pl-4"
            >
            <!-- <span class="hidden-sm-and-down">Pappyon</span> -->
            <a href="https://pappyon.com/">
            <img class="mr-2" src="../assets/whitePappyonLogo.png" height="32"/>
            </a>
            </v-toolbar-title>
      <v-spacer></v-spacer>

     
      <v-menu
        :close-on-content-click="false"
        v-model="menu"
        offset-y
        transition="slide-y-transition"
        content-class="mt-2"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon large v-bind="attrs" v-on="on" class="mr-1">
            <v-avatar size="42px" item color="rgba(255, 255, 255, 0.16)">
              {{ userProfile.firstName[0] + userProfile.lastName[0] }}
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <UserAvatar :usersInitials="userProfile.firstName[0] + userProfile.lastName[0]" :uid="loggedInUsersUid" />
              <v-list-item-content>
                <v-list-item-title>{{ userProfile.firstName }} {{ userProfile.lastName }}</v-list-item-title>
                <v-list-item-subtitle>{{ userProfile.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-list nav>
            <!-- <v-list-item>
              <v-list-item-icon>
                <v-icon>nights_stay</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Dark Mode</v-list-item-title>
              <v-list-item-action>
                <v-switch @change="toggleDarkMode" v-model="darkModeSwitch" color="primary" class="pr-10"></v-switch>
              </v-list-item-action>
            </v-list-item> -->
            <v-list-item
              link
              @click.stop="
                menu = false;
                logoutConfirmationDialog = true;
              "
            >
              <v-list-item-icon>
                <v-icon>exit_to_app</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
             <v-dialog v-model="logoutConfirmationDialog" max-width="410">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>

        <v-card-text>
          <p class="text-subtitle-1">
            Please confirm you want to log out and end your session.
          </p>
          <v-btn class="mt-10 text-body-1" large elevation="0" color="primary" block @click="logoutUser">
            Log Out
          </v-btn>

          <v-btn
            class="mt-2 text-body-1"
            large
            text
            elevation="0"
            color="primary"
            block
            @click="logoutConfirmationDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
          </v-list>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-main>
      <v-container class="fill-height" fluid>
        <slot/>
        <v-row>
          <v-sheet height="50"></v-sheet>
        </v-row>
      </v-container>
      <v-footer padless absolute height="50">
      <v-col
        class="text-center"
        cols="12"
      >
        <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
        <a class="text-caption grey--text mx-8 text-decoration-none" @click="openContactUrl">Contact</a>
        <a class="text-caption grey--text text-decoration-none" @click="openPrivacyPolicyUrl()">Privacy & Terms</a>
      </v-col>
    </v-footer>
    </v-main>
</v-app>
</template>
<script>
  import { mapGetters } from 'vuex';
  import UserAvatar from "@/components/UserAvatar";
  import {getAuth} from "@/shared/firebase_utils";

  export default {
    computed: {
      ...mapGetters(['contactUrl', 'privacyPolicyUrl', 'userProfile', "loggedInUsersUid"]),
      isDarkModeActivated: function () {
        return this.$vuetify.theme.dark;
      },
    },
    methods: {
      openContactUrl() {
        window.open(this.contactUrl);
      },
      openPrivacyPolicyUrl() {
          window.open(this.privacyPolicyUrl);
      },
      async logoutUser() {
      this.logoutConfirmationDialog = false;
      getAuth()
        .signOut()
        .then(async () => {
          this.$vuetify.theme.dark = false;
          // Sign-out successful.
          window.location.reload();
        })
        .catch(function (err) {
          // An error happened.
          console.log(err);
        });
    },
    },
    data() {
      return {
        logoutConfirmationDialog: false,
        menu: false,
      };
    },
    components: {
      UserAvatar,
    },
  }
</script>